module.exports = __webpack_public_path__ + "img/black_logo.eed35d06.png";